import { define } from '../redux-request';
import api from '../../api/api';

export const GET_PHYSICIANS = define('GET_PHYSICIANS');

export function getPhysiciansRequest(data) {
  return GET_PHYSICIANS.request(() => api.getPhysicians(data));
}

export const GET_PHYSICIAN_SCRIPT = define('GET_PHYSICIAN_SCRIPT');

export function getPhysicianScriptRequest(data) {
  return GET_PHYSICIAN_SCRIPT.request(() => api.getPhysicians(data));
}

export const GET_PHYSICIAN_USERS = define('GET_PHYSICIAN_USERS');

export function getPhysicianUsersRequest(data) {
  return GET_PHYSICIAN_USERS.request(() => api.getUserList(data));
}

export const GET_PHYSICIAN_NOTES = define('GET_PHYSICIAN_NOTES');

export function getPhysicianNotesRequest(data) {
  return GET_PHYSICIAN_NOTES.request(() => api.getPhysicianNotes(data));
}

export const GET_PHYSICIAN_VISITS = define('GET_PHYSICIAN_VISITS');

export function getPhysicianVisitsRequest(data) {
  return GET_PHYSICIAN_VISITS.request(() => api.getPhysicianVisits(data));
}

export const ADD_VISITS = define('ADD_VISITS');

export function addVisitRequest(data) {
  return ADD_VISITS.request(() => api.addVisit(data));
}

export const EDIT_VISIT = define('EDIT_VISIT');

export function editVisitRequest(data) {
  return EDIT_VISIT.request(() => api.editVisit(data));
}

export const DELETE_VISIT = define('DELETE_VISIT');

export function deleteVisitRequest(id) {
  return DELETE_VISIT.request(() => api.deleteVisit(id));
}

export const ADD_PHYSICIAN_NOTE = define('ADD_PHYSICIAN_NOTE');

export function addPhysicianNoteRequest(data) {
  return ADD_PHYSICIAN_NOTE.request(() => api.addPhysicianNote(data)).onSuccess(() => data);
}

export const GET_PHYSICIAN_GROUP_NOTES = define('GET_PHYSICIAN_GROUP_NOTES');

export function getPhysicianGroupNotesRequest(data) {
  return GET_PHYSICIAN_GROUP_NOTES.request(() => api.getPhysicianGroupNotes(data));
}

export const ADD_PHYSICIAN_GROUP_NOTE = define('ADD_PHYSICIAN_GROUP_NOTE');

export function addPhysicianGroupNoteRequest(data) {
  return ADD_PHYSICIAN_GROUP_NOTE.request(() => api.addPhysicianGroupNote(data)).onSuccess(() => data);
}

export const GET_PHYSICIAN_GROUP_USERS = define('GET_PHYSICIAN_GROUP_USERS');

export function getPhysicianGroupUsersRequest(data) {
  return GET_PHYSICIAN_GROUP_USERS.request(() => api.getPhysicianGroupUsers(data));
}
